export default __webpack_public_path__ + "static/media/terms.dff5370d.jpg";